module.exports = __webpack_public_path__ + "img/hr-tree-05-h-leaves.8bcc1308.png";